require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/utils/fallbacks.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/utils/fallbacks.legacy.js
// module id = 656
// module chunks = 31